import { RedoOutlined } from '@ant-design/icons';
import { Table, Paging, usePaging, useUpdate, EllipsisSpan, MultiSelect, CustomFilter,Select } from '@maxtropy/components';
import { Button, Form, Input } from 'antd';
import { FC, Key, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IotProtocolType } from '@/shared/types';
import { BatchRuleGroupPageRequest } from '../../../../api/ruleGroup';
import { RuleGroupPageProps } from './types';
import styles from './index.module.scss';
import { apiV2RuleRulePagePost,apiV2RuleGroupDeviceAllRuleGroupPost } from '@maxtropy/tody-mgmt-apis-v2';
import { AlarmStatus, alarmStatusDisplay, alarmStatusOptions } from '../../BatchBindRuleGroup/SelectRuleGroup/types';

const columns = [
  {
    title: '规则名称',
    dataIndex: 'name',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '规则状态',
    dataIndex: 'status',
    ellipsis: { showTitle: true },
    render: (v: AlarmStatus) => <EllipsisSpan value={alarmStatusDisplay[v]} />,
  },
  {
    title: '规则编号',
    dataIndex: 'code',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '所属规则组',
    dataIndex: 'ruleGroupName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  // {
  //   title: '报警标签',
  //   dataIndex: 'ruleCount',
  //   ellipsis: { showTitle: true },
  //   render: (v: string) => <EllipsisSpan value={v} />,
  // },
];

export interface SelectRuleGroupModalChildrenProps {
  deviceId: Key;
  rootMcid?: string;
  deviceTypeId?: number;
  iotProtocol?: IotProtocolType;
  value?: number[];
  physicalModelId?: number;
  onChange?: (val: number[]) => void;
  unBind?: () => void;
}

type SearchParams = Omit<BatchRuleGroupPageRequest, 'rootMcid' | 'iotProtocol' | 'size' | 'page'>;

const SelectRuleGroupModalChildren: FC<SelectRuleGroupModalChildrenProps> = ({
  deviceId,
  rootMcid,
  deviceTypeId,
  iotProtocol,
  value,
  physicalModelId,
  onChange,
  unBind,
}) => {
  const [form] = Form.useForm();

  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  const [searchParams, setSearchParams] = useState<SearchParams>();
  const [ruleGroups, setRuleGroups] = useState<RuleGroupPageProps[]>([]);
  const [updateState, updateFn] = useUpdate();

  const [loading, setLoading] = useState<boolean>(false);
  const [selectRowsKeys, setSelectRowsKeys] = useState<React.Key[]>([]);
  const [nameOptions, setNameOptions] = useState<RuleGroupPageProps[]>([]);
  // useEffect(() => {
  //   if (deviceId !== undefined) {
  //     setLoading(true);
  //     getDeviceRuleGroupPage({ ...searchParams, deviceId: deviceId.toString(), page: pageOffset, size: pageSize}).then(res => {
  //       setLoading(false);
  //       if (res) {
  //         setTotalCount(res.total);
  //         setRuleGroups(res.list);
  //       }
  //     })
  //   }
  // }, [deviceId, pageOffset, pageSize, searchParams, setTotalCount, updateState]);

  useEffect(() => {
    if (rootMcid && iotProtocol !== undefined) {
      setLoading(true);
      apiV2RuleRulePagePost({
        ...searchParams,
        rootMcid,
        typeId: deviceTypeId,
        // iotProtocol,
        // physicalModelId,
        page: pageOffset,
        size: pageSize,
      }).then(res => {
        setLoading(false);
        if (res) {
          setTotalCount(res.total ?? 0);
          res.list && setRuleGroups(res.list);
          setSelectRowsKeys((value as Key[]) ?? []);
        }
      }).finally(()=>setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootMcid, iotProtocol, pageOffset, pageSize, searchParams, setTotalCount, updateState]);

  useEffect(() => {
    if (rootMcid && iotProtocol !== undefined) {
      // 这个接口就是还要传nameOrCode
      apiV2RuleGroupDeviceAllRuleGroupPost({
        nameOrCode:searchParams?.codeOrNameLike,
        rootMcid,
        deviceTypeId,
        iotProtocol,
        physicalModelId,
      }).then(res => {
        if (res) {
          res.list && setNameOptions(res.list);
        }
      });
    }
  }, []);


  const onFinish = (value: SearchParams) => {
    setSearchParams(value);
    setPageOffset(1);
  };

  const onReset = () => {
    setSearchParams({});
    form.setFieldsValue({
      codeOrNameLike: undefined,
      ruleGroupIdList: undefined,
    });
    setPageOffset(1);
  };

  
  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRows: React.Key[]) => {
      setSelectRowsKeys(selectedRows);
      onChange?.(selectedRows.map(r => Number(r)));
    },
    getCheckboxProps: (record:RuleGroupPageProps) => {
      const disabled = record.id === value
      return {
      disabled: disabled, 
    }},
    selectedRowKeys: selectRowsKeys,
  };


  const filters = (
    <CustomFilter
      form={form}
      onFinish={val => {
        onFinish(val as SearchParams);
      }}
      colSpan={8}
      onReset={onReset}
    >
      <Form.Item name="codeOrNameLike" label="编号/名称">
        <Input placeholder="请输入编号或名称查询" />
      </Form.Item>
      <Form.Item label="规则组名称" name="ruleGroupIdList">
        <MultiSelect
          placeholder="请选择"
          showSearch
          options={nameOptions.map(i => ({ label: i.name, value: i.id }))}
        ></MultiSelect>
      </Form.Item>
      <Form.Item label="报警状态" name="status">
        <Select placeholder="请选择" allowClear options={alarmStatusOptions} />
      </Form.Item>
    </CustomFilter>
  );

  return (
    <>
      {filters}
      <div className={styles.tips}>
        <span>
          <Button onClick={unBind} type="link">
            全部移除
          </Button>
          <Button type="link">
            <Link to={`/device/rule/list/group/create`} target="_blank">
              新建规则组
            </Link>
          </Button>
          <Button style={{ padding: 0, paddingLeft: 2, paddingRight: 2, height: 24 }} onClick={updateFn} type="link">
            <div>
              <RedoOutlined rotate={270} />
              刷新页面
            </div>
          </Button>
        </span>
      </div>
      <Table
        loading={loading}
        sticky
        scroll={{ y: 300 }}
        rowKey="id"
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={columns}
        dataSource={ruleGroups}
      />
      <Paging pagingInfo={pagingInfo} />
    </>
  );
};

export default SelectRuleGroupModalChildren;
